import { render, staticRenderFns } from "./Recordings.vue?vue&type=template&id=0d0f901a&"
import script from "./Recordings.vue?vue&type=script&lang=js&"
export * from "./Recordings.vue?vue&type=script&lang=js&"
import style0 from "./Recordings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports